module.exports = __webpack_public_path__ + "src/app/_content/imgs/bmw/icons/social/facebook-default@2x.png?8273f1856b0554f9ed460c1e2b496247";